// DenunciaQR.jsx
import React from "react";
import "./denunciaQR.css";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom";

export default function DenunciaQR() {
  const routePath = "/DenunciaQRInfo";
  const qrUrl = `${window.location.origin}${routePath}`; // full URL for phone scanners

  return (
    <div>
      <h3 className="title">DENUNCIA TOMAS CLANDESTINAS</h3>
      <hr className="hr-gob" />

      <div className="myContainer">
        {/* Link = internal navigation (no reload) */}
        <Link
          to={routePath}
          className="qrLink d-block"
          aria-label="Abrir formulario de denuncia"
          title="Abrir formulario de denuncia"
        >
          <div className="qrBox">
            {/* QR code points to your app's full URL */}
            <QRCode value={qrUrl} size={220} />
          </div>
          <p className="qrText">Escanea o haz clic para abrir</p>
        </Link>
      </div>
    </div>
  );
}
